import api from "@/configuration/api";

export const posts = {
    list: (data) => api.get('posts', data),
    getOne: (id) => api.get('posts/' + id),
    getListImages: (id) => api.get(`posts/${id}/images`),
};
